import React, { useMemo } from 'react';
import { Pagination } from "swiper/modules";

import {FormContainer} from '@components/organisms/MultiStepForm/MultiStepForm.styled';
import MultiStepLayout from '@components/organisms/MultiStepForm/Steps/MultiStepLayout/MultiStepLayout';
import ProgressBar from '@components/atoms/ProgressBar/ProgressBar';
import StepElement from '@components/organisms/MultiStepForm/Steps/StepElement/StepElement';
import {
  FormBlock,
  FullPageLayout,
  PresentationBlock,
  SwiperSlideStyled,
  SwiperStyled,
  AvisVerifiesSwiperContainer,
  FullWidthDiv,
  PresentationIntro, PresentationIntroBlock, ReassuranceText,
  LeftColumnLayoutDiv,
  LogoHorizontalDiv,
  FooterCopyright
} from './MultiPage.styled';

import AvisVerifiesLogo from '@components/atoms/Icon/svg/AvisVerifiesLogo';
import {isDesktop, isMobile} from 'react-device-detect';
import { formConfig } from "@config/formConfig";

import 'swiper/css';
import 'swiper/css/pagination';
import Icon from "@components/atoms/Icon/Icon";
import {TYPE_GREEN_BLUE} from "@components/atoms/Icon/svg/Arrow";
import ArrowBackground from "@components/atoms/Icon/svg/ArrowBackground";
import AvisNumberPartial from './AvisNumberPartial';
import LogoHorizontal from '@components/molecules/Logo/LogoHorizontal';
import { isIpac } from '@config/constants';
import LogoIPacOnline from '@components/molecules/Logo/LogoIPacOnline';
import DisplayLogo from '@components/molecules/Logo/DisplayLogo';

const MultiPage = ({
  currentStep,
  maxStep,
  visibleSteps,
  handleSubmit,
  handleInvalid,
  formDataContext,
  trainingId,
  phrases,
  handleNextStep,
  handleFormData,
  isSubmitting,
  handlePrevStep,
  config,
}) => {
  const swiperSlides = useMemo(() => {
    const avis = formConfig?.avis.sort(() => Math.random() - 0.5);
    return (
        <SwiperStyled
            pagination={{ clickable: true }}
            modules={[Pagination]}
            loop={true}
            autoHeight={true}
        >
          {avis?.map((slide, index) => (
              <SwiperSlideStyled key={index}>
                <div>
                  <p>{slide.title}</p>
                  <p>{slide.description}</p>
                  <AvisVerifiesSwiperContainer>
                    <p>{slide.name}</p>
                    <AvisVerifiesLogo/>
                    <span>★★★★★</span>
                  </AvisVerifiesSwiperContainer>
                </div>
              </SwiperSlideStyled>
          ))}
        </SwiperStyled>
    );
  }, []);

  const renderMobileLeftColumn = () => {
    
    return (
      <React.Fragment>
        {
          currentStep < 7 ?
          <React.Fragment>
            <ReassuranceText>
              + de 130 000 apprenants nous font confiance
            </ReassuranceText>
            <AvisNumberPartial />
            <PresentationIntroBlock>
              <PresentationIntro>
                <Icon name={'computerscreen'}/>
                <p>
                  Webinaires personnalisés
                </p>
              </PresentationIntro>
              <PresentationIntro>
                <Icon name={'hand'}/>
                <p>
                  Rendez-vous avec un mentor/coachs
                </p>
              </PresentationIntro>
              <PresentationIntro>
                <Icon name={'graduationcap'}/>
                <p>
                  Formation certifiante / diplomante
                </p>
              </PresentationIntro>
              <PresentationIntro>
                <Icon name={'computergraph'}/>
                <p>
                  Des vidéos 100 % exclusives
                </p>
              </PresentationIntro>
            </PresentationIntroBlock>
          </React.Fragment>
          :
          <React.Fragment>
            <ReassuranceText>
              Voici ce qui vous attend après avoir rempli notre formulaire :
            </ReassuranceText>
            <PresentationIntroBlock>
              <PresentationIntro>
                <Icon name={'headset'}/>
                <p>
                  <span>Un conseiller expert</span> vous contactera rapidement pour faire le point sur votre projet,
                  définir vos objectifs et choisir la formation la plus adaptée.
                </p>
              </PresentationIntro>
            </PresentationIntroBlock>
          </React.Fragment>
        }
      </React.Fragment>
    );
  }

  const renderDesktopLeftColumn = () => {
    
    return (
      <React.Fragment>
        {
          currentStep < 7 ?
          <React.Fragment>
            <LeftColumnLayoutDiv>
              <LogoHorizontalDiv>
                <DisplayLogo />
              </LogoHorizontalDiv>
              <FullWidthDiv>
                { swiperSlides }
                <AvisNumberPartial />
              </FullWidthDiv>
            </LeftColumnLayoutDiv>
          </React.Fragment>
          :
          <React.Fragment>
            <LeftColumnLayoutDiv>
              <LogoHorizontalDiv>
                <DisplayLogo />
              </LogoHorizontalDiv>
              <FullWidthDiv>
                <PresentationIntroBlock>
                  <PresentationIntro>
                    <Icon name={'lightbulb'}/>
                    <p>
                      <span>Voici ce qui vous attend après avoir rempli notre formulaire:</span>
                    </p>
                  </PresentationIntro>
                  <PresentationIntro>
                    <Icon name={'headset'}/>
                    <p>
                      <span>Un conseiller expert</span> vous contactera rapidement pour faire le point sur votre
                      projet,
                      définir vos objectifs et choisir la formation la plus adaptée.
                    </p>
                  </PresentationIntro>
                  <PresentationIntro>
                    <Icon name={'calendar'}/>
                    <p>
                      Ensemble, vous découvrirez <span>les solutions de financement disponibles</span> et fixerez
                      votre <span>date de début</span>.
                    </p>
                  </PresentationIntro>
                  <PresentationIntro>
                    <Icon name={'arrow'} type={TYPE_GREEN_BLUE}/>
                    <p>
                      <span>Un appel, un accompagnement, un nouvel avenir</span>: tout commence ici !
                    </p>
                  </PresentationIntro>
                </PresentationIntroBlock>
              </FullWidthDiv>
            </LeftColumnLayoutDiv>
          </React.Fragment>
        }
      </React.Fragment>
    );
  }

  return (
    <FullPageLayout>
      <PresentationBlock>
        {
          isDesktop ? renderDesktopLeftColumn() : renderMobileLeftColumn()
        }
        {isDesktop && <ArrowBackground />}
      </PresentationBlock>
      <FormBlock>
        {
          isMobile && <LogoHorizontalDiv><DisplayLogo /></LogoHorizontalDiv>
        }
        <ProgressBar currentStep={currentStep} maxStep={maxStep} />
        <FormContainer>
          <form onSubmit={handleSubmit} onInvalid={handleInvalid} style={{width: '100%'}}>
            <MultiStepLayout
              currentStep={currentStep}
              maxStep={maxStep}
              handlePrevStep={handlePrevStep}
            >
              {config
                .filter(
                  (step) => step.index === visibleSteps[currentStep - 1]?.index
                )
                .map((filteredStep) => (
                  <React.Fragment key={filteredStep.index}>
                    <StepElement
                      stepData={filteredStep}
                      formDataContext={formDataContext}
                      trainingId={trainingId}
                      phrases={phrases}
                      handleNextStep={handleNextStep}
                      handleFormData={handleFormData}
                      isSubmitting={isSubmitting}
                      currentStep={currentStep}
                      maxStep={maxStep}
                    />
                  </React.Fragment>
                ))}
            </MultiStepLayout>
          </form>
          <FooterCopyright>
            © 2009 • { new Date().getFullYear() } - { isIpac ? 'IPAC ONLINE' : "L’École Française" } 
          </FooterCopyright>
        </FormContainer>
      </FormBlock>
    </FullPageLayout>
  );
};

export default MultiPage;
